const BASE_URL = "/api/personal-accident";
export const GET_SPOT_ID_ENDPOINT = `/api/get-spot-id`;
export const PRODUCT_LIST_ENDPOINT = `${BASE_URL}/quick-quote`;
export const POLICY_HIGHLIGHT_ENDPOINT = `${BASE_URL}/policy-highlight-details`;
export const CREATE_QUOTE_CONFIG_ENDPOINT = `${BASE_URL}/create-quote-config`;
export const CREATE_QUOTE_ENDPOINT = `${BASE_URL}/create-quote`;
export const KYC_API_ENDPOINT = `${BASE_URL}/kyc-process`;
export const PINCODE_API_ENDPOINT = `${BASE_URL}/pincode-details`;
export const TRANSFER_DATA_API_ENDPOINT = `${BASE_URL}/transfer-data`;
export const SEND_PAYMENT_LINK_TO_CUSTOMER_API_ENDPOINT = `/api/send-payment-link`;
export const CHECK_PAYMENT_STATUS_API_ENDPOINT = `/api/check-status`;
export const RELIANCE_PAYMENT_REDIRECT_API_ENDPOINT = `${BASE_URL}/reliance-payment-redirect`;
export const GET_FORMIK_VALUES_API_ENDPOINT = `${BASE_URL}/formik-values`;
export const POLICY_DOWNLOAD_API_ENDPOINT = `${BASE_URL}/reliance-policy-download`;
